export const approvalChecked = (data: number) => {
    if(data === 1) { return "Pending" }
    if(data === 2) { return "Revisi" }
    if(data === 3) { return "Rejected" }
    if(data === 4) { return "Approved" }
    return "-"
  }